import makeList from './makeList.js'

let viewFloor = 'east'

let params = [
  {
    name: 'syowa',
    locations: [
      { description: '発電棟前',
        file: './data/10_R0010762.JPG',
        rotation: 28.545938748335246,
        link: [
          {
            file: './data/11_R0010666.JPG',
            position: [ 4007.16368250964, 81.40832510567073, -2980.6795468889745 ],
          },
          {
            file: './data/10b_R0010669.JPG',
            position: [ 1381.071502647993, -243.6526172016723, 4789.3324863254165 ],
          },
          {
            file: './data/I13f_2.JPG',
            position: [ -4816.215413558389, 589.7551219110157, 1168.0352115062044 ],
          },
          {
            file: './data/09_R0010761.JPG',
            position: [ -1717.1840156495716, -17.709820035123464, 4688.475636496028 ],
          },
          {
            file: './data/14_R0010763.JPG',
            position: [ -4114.809523246195, -50.30181892260988, -2827.9360719829842 ],
          },
        ],
        info: [
          {
            name: 'smallGenerators',
            position: [ 1350.605810164064, 173.56304219979384, -4800.3428266508245 ],
          },
          {
            name: '100l',
            position: [ -4565.236126499058, 93.17382181194182, -2029.9712171334902 ],
          },
          {
            name: 'generator',
            position: [ -4633.598106790053, 466.76297095813857, 1794.5723946527946 ],
          },
        ],
        view: {
          syowa: [ 478.84187082405344, 376.39198218262806 ],
          syowaZoom: [ 890.8685968819599, 711.6636971046771 ],
        },
      },
      { description: '海岸付近',
        file: './data/10b_R0010669.JPG',
        rotation: -109.98633268221693,
        link: [
          {
            file: './data/10_R0010762.JPG',
            position: [ -230.47919626646174, 82.67617546202698, -4984.672645619314 ],
          },
        ],
        info: [
          {
            name: 'observer',
            position: [ -1741.8585440624445, 180.50781269838347, 4672.16200851333 ],
          },
        ],
        view: {
          syowa: [ 458.79732739420933, 432.07126948775056 ],
          syowaZoom: [ 868.5968819599109, 805.2048997772829 ],
        },
      },
      { description: '観測棟前',
        file: './data/11_R0010666.JPG',
        rotation: -61.335616274427686,
        link: [
          {
            file: './data/10_R0010762.JPG',
            position: [ -3811.8176701805, -736.7575885818343, 3137.833710049335 ],
          },
          {
            file: './data/12_R0010664.JPG',
            position: [ 4033.4452223209155, -232.01703249855024, -2938.834469794365 ],
          },
          {
            file: './data/I3f.JPG',
            position: [ -1826.3483354972825, 497.9308479462271, -4617.454490174204 ],
          },
        ],
        info: [
          {
            name: 'environmental',
            position: [ -4705.2107100139965, -247.7481810199713, 1648.4017281343279 ],
          },
          {
            name: 'observationWarehouse',
            position: [ -4575.5141721311675, -585.7021115451182, -1906.6583650493997 ],
          },
        ],
        view: {
          syowa: [ 360.8017817371938, 322.93986636971044 ],
          syowaZoom: [ 694.8775055679287, 618.1224944320713 ],
        },
      },
      { description: '情報処理棟前',
        file: './data/12_R0010664.JPG',
        rotation: -160.22432346559125,
        link: [
          {
            file: './data/11_R0010666.JPG',
            position: [ -4448.84706994513, -542.1382428735952, 2194.0832156253514 ],
          },
          {
            file: './data/I12.JPG',
            position: [ -3382.605711289424, -385.1434784292086, -3657.400515876162 ],
          },
          {
            file: './data/I15.JPG',
            position: [ 1392.2801453979052, -55.21042125474573, -4793.983921621538 ],
          },
          {
            file: './data/13_R0010796.JPG',
            position: [ 3094.119827288821, 387.59452951248744, -3899.842906170981 ],
          },
          {
            file: './data/45_R0010787.JPG',
            position: [ 4592.29838918002, -363.6237721641867, 1929.8614817937228 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 320.71269487750556, 298.44097995545656 ],
          syowaZoom: [ 614.6993318485523, 582.4877505567929 ],
        },
      },
      { description: '情報処理棟入口前',
        file: './data/I12.JPG',
        rotation: -56.43756460104926,
        link: [
          {
            file: './data/12_R0010664.JPG',
            position: [ 4167.105609023087, -518.7651551657207, 2695.3235763545817 ],
          },
          {
            file: './data/I12e.JPG',
            position: [ 2567.809544545409, 669.5208935164405, -4228.667923646318 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 345.21158129175944, 278.39643652561244 ],
          syowaZoom: [ 670.3786191536748, 520.1269487750556 ],
        },
      },
      { description: '衛星受信棟・光学観測棟入口',
        file: './data/I15.JPG',
        rotation: -15.707599160207295,
        link: [
          {
            file: './data/12_R0010664.JPG',
            position: [ 3191.6559400612723, -650.8785268984799, 3781.294561998795 ],
          },
          {
            file: './data/13_R0010796.JPG',
            position: [ 4749.316161479966, -407.81689318275346, -1500.792587671139 ],
          },
          {
            file: './data/I31a.JPG',
            position: [ -583.7738158546374, -870.5506433547208, 4882.912546068578 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 312.0567375886525, 238.29787234042553 ],
          syowaZoom: [ 598.581560283688, 449.17021276595733 ],
        },
      },
      { description: '衛星受信棟前',
        file: './data/13_R0010796.JPG',
        rotation: -24.91918200942622,
        link: [
          {
            file: './data/12_R0010664.JPG',
            position: [ -847.6276515392344, -754.5972780431518, 4862.196447104381 ],
          },
          {
            file: './data/I15.JPG',
            position: [ -4299.186877241501, -1029.9874078721705, 2316.88625748641 ],
          },
          {
            file: './data/47_R0010789.JPG',
            position: [ 2689.423037730639, 866.546276904133, -4113.830898552689 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 258.3518930957684, 238.30734966592428 ],
          syowaZoom: [ 514.4766146993319, 451.0846325167038 ],
        },
      },
      { description: 'レドーム遠景',
        file: './data/47_R0010789.JPG',
        rotation: 134.93001351164924,
        link: [
          {
            file: './data/I45.JPG',
            position: [ -1701.7002003005318, -696.7222461646918, -4640.134612775873 ],
          },
          {
            file: './data/13_R0010796.JPG',
            position: [ -1542.0238442640268, -1271.3280823168868, 4577.275919934276 ],
          },
          {
            file: './data/46_R0010788.JPG',
            position: [ 4123.893261612605, -582.710431477378, 2747.987550097128 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 224.94432071269486, 162.58351893095767 ],
          syowaZoom: [ 434.29844097995544, 288.5011135857461 ],
        },
      },
      { description: '多目的アンテナレドーム入口',
        file: './data/I45.JPG',
        rotation: -42.53833965028851,
        link: [
          {
            file: './data/48_R0010790.JPG',
            position: [ -231.6866507151972, -315.09384497266893, -4975.477739251293 ],
          },
          {
            file: './data/47_R0010789.JPG',
            position: [ 1851.5280231310303, 379.72601238705056, 4621.691044409028 ],
          },
          {
            file: './data/I45a.JPG',
            position: [ 3372.634071270492, 157.663787884596, -3679.9946250196467 ],
          },
        ],
        info: [
          {
            name: 'redome',
            position: [ 3821.069650622347, 1573.8297815237838, -2810.4076223286474 ],
          },
        ],
        view: {
          syowa: [ 244.98886414253897, 120.26726057906458 ],
          syowaZoom: [ 467.70601336302894, 223.913140311804 ],
        },
      },
      { description: '多目的アンテナエリア中心',
        file: './data/48_R0010790.JPG',
        rotation: 140.86501691022139,
        link: [
          {
            file: './data/I45.JPG',
            position: [ 2196.387684829636, 13.332132468531938, 4484.237961821896 ],
          },
          {
            file: './data/I17.jpeg',
            position: [ -3549.7998698552374, -234.83799094070724, -3498.5465584532812 ],
          },
          {
            file: './data/I22.jpeg',
            position: [ -4863.264431470725, -373.5249052372628, -1085.4663459605677 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 249.44320712694878, 77.95100222717149 ],
          syowaZoom: [ 476.61469933184856, 145.96213808463244 ],
        },
      },
      { description: '重力計室前',
        file: './data/I17.jpeg',
        rotation: -15.032048917351588,
        link: [
          {
            file: './data/48_R0010790.JPG',
            position: [ 3839.2915186622517, -356.50992689006165, 3170.8326408198773 ],
          },
          {
            file: './data/I22.jpeg',
            position: [ 587.3748164219037, -845.9914360239354, 4887.281406715863 ],
          },
          {
            file: './data/49_R0010791.JPG',
            position: [ -4768.591208509155, -481.39689432557265, 1395.255484848348 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 285.07795100222717, 40.089086859688194 ],
          syowaZoom: [ 543.4298440979956, 76.91982182628055 ],
        },
      },
      { description: '地震計室前',
        file: './data/I22.jpeg',
        rotation: 89.79955733295256,
        link: [
          {
            file: './data/I17.jpeg',
            position: [ -71.92009377354074, -874.9294120112164, -4916.2221322534615 ],
          },
          {
            file: './data/48_R0010790.JPG',
            position: [ 4739.499871477052, -657.486933652072, -1423.4106303263047 ],
          },
          {
            file: './data/49_R0010791.JPG',
            position: [ -4782.811954021175, -522.8293357181652, -1323.2616301365517 ],
          },
          {
            file: './data/I22a.JPG',
            position: [ 2695.178458599305, -407.4505963203719, 4182.887660436489 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 305.1224944320713, 71.26948775055679 ],
          syowaZoom: [ 594.6547884187082, 132.5991091314031 ],
        },
      },
      { description: '多目的アンテナエリア端',
        file: './data/49_R0010791.JPG',
        rotation: 180,
        link: [
          {
            file: './data/I17.jpeg',
            position: [ 4862.531311243315, -1046.014952847821, 447.04669006897956 ],
          },
          {
            file: './data/I22.jpeg',
            position: [ 2851.8651349558318, -1043.9098307458337, 3966.3309940322856 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 329.62138084632517, 44.543429844097986 ],
          syowaZoom: [ 619.1536748329621, 81.37416481069044 ],
        },
      },
      { description: 'インテルサットエリア前',
        file: './data/45_R0010787.JPG',
        rotation: -130,
        link: [
          {
            file: './data/12_R0010664.JPG',
            position: [ -4571.418665580964, -245.99939189973063, -1997.1330971142406 ],
          },
          {
            file: './data/46_R0010788.JPG',
            position: [ 1784.3273632881305, -713.6241847159272, -4606.277173481726 ],
          },
          {
            file: './data/I36.JPG',
            position: [ 3391.5355172916966, -1115.724316202786, 3489.2032385623 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 189.30957683741647, 273.94209354120267 ],
          syowaZoom: [ 354.12026726057906, 551.3073496659242 ],
        },
      },
      { description: 'インテルサットレドーム入口',
        file: './data/I36.JPG',
        rotation: 70,
        link: [
          {
            file: './data/45_R0010787.JPG',
            position: [ -4650.819251748561, -490.0018202668234, -1742.045241693661 ],
          },
        ],
        info: [
          {
            name: 'intelSatRedome',
            position: [ 3533.035594155871, 147.24685200078238, 3520.171120555389 ],
          },
        ],
        view: {
          syowa: [ 162.5835189309577, 309.57683741648106 ],
          syowaZoom: [ 307.34966592427617, 595.8507795100222 ],
        },
      },
      { description: '清浄大気観測小屋前',
        file: './data/I35e.JPG',
        rotation: -60,
        link: [
          {
            file: './data/I35d.JPG',
            position: [ 4319.209604971952, 1632.1086613969796, -1909.7006085553287 ],
          },
          {
            file: './data/44_R0010786.JPG',
            position: [ 906.4829848057611, 144.2313370023339, -4906.085394069842 ],
          },
        ],
        info: [
          {
            name: 'freshAir',
            position: [ 2406.187334379464, 247.29833626724292, -4367.036942759859 ],
          },
        ],
        view: {
          syowa: [ 69.04231625835189, 354.12026726057906 ],
          syowaZoom: [ 133.63028953229397, 660.4387527839644 ],
        },
      },
      { description: '清浄大気観測小屋屋上',
        file: './data/I35d.JPG',
        rotation: -35,
        link: [
          {
            file: './data/I35a.JPG',
            position: [ -3052.0239935739087, -1701.0171865299214, 3565.117972304744 ],
          },
          {
            file: './data/44_R0010786.JPG',
            position: [ 1860.752611739199, -362.53229780098786, -4618.872661190354 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 51.224944320712694, 336.30289532293983 ],
          syowaZoom: [ 100.22271714922049, 649.3028953229398 ],
        },
      },
      { description: 'ライフロープ沿い',
        file: './data/46_R0010788.JPG',
        rotation: 5,
        link: [
          {
            file: './data/45_R0010787.JPG',
            position: [ -60.056035137237004, -938.3123145285205, 4904.2361898776335 ],
          },
          {
            file: './data/47_R0010789.JPG',
            position: [ -2560.9944154881787, -50.914390031819, -4288.1347348926665 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 173.71937639198217, 209.35412026726058 ],
          syowaZoom: [ 354.12026726057906, 388.72383073496667 ],
        },
      },
      { description: 'PANSYエリア遠景',
        file: './data/44_R0010786.JPG',
        rotation: -120,
        link: [
          {
            file: './data/I35d.JPG',
            position: [ -1948.449170786539, 93.90996753437848, 4596.498630402924 ],
          },
          {
            file: './data/I36.JPG',
            position: [ -4041.561671714835, 41.072408219522295, 2940.716407430368 ],
          },
          {
            file: './data/I35a.JPG',
            position: [ -2554.2180844794016, -183.05233792810097, 4286.353479711288 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 31.180400890868597, 244.98886414253894 ],
          syowaZoom: [ 64.5879732739421, 448.8574610244989 ],
        },
      },
    ],
  },
]

export default makeList(params,viewFloor)
